import { useQuery } from 'react-query';
import axios from 'axios';
import * as yup from 'yup';
import { taskSchema } from '~/schemas/taskSchema';
const responseSchema = yup
    .object()
    .camelCase()
    .required()
    .shape({
    message: yup.string().required().oneOf(['OK']),
    data: yup
        .array()
        .defined()
        .of(taskSchema),
});
async function getTasksForPatient(patientId) {
    const response = await axios.post('/api/tasks/getTasksForPatient', {
        patient_id: patientId,
    });
    const { data } = await responseSchema.validate(response.data);
    return {
        // @ts-ignore
        tasks: data,
    };
}
export const useTasksForPatient = ({ patientId, }) => {
    return useQuery(['tasksForPatient', patientId], () => getTasksForPatient(patientId), {
        staleTime: 60000,
        refetchOnWindowFocus: true,
    });
};
